import React, { Fragment, useState, useRef, useEffect } from 'react'
import { Container, Row, Col } from 'react-bootstrap'
// import Link from 'next/link'
// import LogoSlider from '../../components/LogoSlider';
import styles from './google-review.module.scss'
import Image from 'next/image'
import Carousel from 'react-bootstrap/Carousel'
import { useSelector } from 'react-redux'
import useMixpanel from '../../Hooks/useMixpanel'
//import Testimonial from '../../components/Testimonial'


function useOutsideAlerter(ref, setTestimonialID) {
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setTestimonialID(null)
      }
    }

    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [ref])
}

const index = () => {
  const auth = useSelector((state) => state.auth)
  // useMixpanel(auth, 'view_customer_reviews_page_web')

  const [testimonialID, setTestimonialID] = useState(null)

  const handleShowVideo = (vimeoID) => {
    // console.log("handle show video", vimeoID)
    setTestimonialID(vimeoID)
  }

  const handleCloseVideo = () => {
    setTestimonialID(null)
  }

  let slideData = [
    {
      img: '/testimonial/aiden-dutta.jpg',
      id: 'https://player.vimeo.com/video/671414452?autoplay=1&h=09f6c79088',
      alt: "Aiden got admitted to his dream college, 'The University of Pennsylvania.'",
    },
    {
      img: '/testimonial/Anishka.png',
      m_img: '/Verticle-success-stories/anishka_bompelli.jpg',
      id: 'https://player.vimeo.com/video/535852056?autoplay=1',
      alt: 'Anishka has been admitted to Carnegie Mellon, Georgia Tech, UC Berkeley, UC San Diego, etc.',
    },
    {
      img: '/testimonial/ansh-got-admitted-to-Rotman-School-of-Management-(UofT).jpg',
      m_img: '/Verticle-success-stories/ansh_gupta.jpg',
      id: 'https://player.vimeo.com/video/702324705?autoplay=1&h=56e0361755',
      alt: 'Ansh started his journey with CollegePass in 2020 and has been admitted to his Dream college',
    },
    {
      img: '/testimonial/pankhuri-image-landscape.jpg',
      m_img: '/Verticle-success-stories/pankhuri.jpg',
      id: 'https://player.vimeo.com/video/689536463?autoplay=1&h=a97cecb20a',
      alt: 'Pankhuri started her journey with collegePass',
    },
    {
      img: '/testimonial/Khushi.png',
      m_img: '/Verticle-success-stories/khushi.jpg',
      id: 'https://player.vimeo.com/video/573945142?autoplay=1',
      alt: 'Khushi has been admitted to the University of Warwick, University of Manchester, Kings College London, UCLA.',
    },
    {
      img: '/testimonial/Krutibas.png',
      m_img: '/Verticle-success-stories/khushi_sampat.jpg',
      id: 'https://player.vimeo.com/video/518969166?autoplay=1',
      alt: 'Tanush and Tishya got into UIUC, Purdue University, UMass Amherst, Wisconsin Madison, etc.',
    },
    {
      img: '/testimonial/Neeraj.png',
      m_img: '/Verticle-success-stories/neeraj_nair.jpg',
      id: 'https://player.vimeo.com/video/520822820?autoplay=1',
      alt: "Niraj got admitted to his dream college, 'New York University.'",
    },
    {
      img: '/testimonial/Dhruv.png',
      m_img: '/Verticle-success-stories/dhruv_venkataraman.jpg',
      id: 'https://player.vimeo.com/video/510641183?autoplay=1',
      alt: 'Dhruv has been admitted to Wisconsin Madison, Ohio State, Stony Brook, Boston University, etc.',
    },

    {
      img: '/testimonial/Pratibha.png',
      m_img: '/Verticle-success-stories/pratibha_nair.jpg',
      id: 'https://player.vimeo.com/video/541041438?autoplay=1',
      alt: "Pratibha's son Niraj got admitted to his dream college, 'New York University.'",
    },

    {
      img: '/testimonial/priyanshu-got-admitted-to-purdue-georgia-tech-uiuc.png',
      m_img: '/Verticle-success-stories/priyanka_mehta.jpg',
      id: 'https://player.vimeo.com/video/702325210?autoplay=1&h=9f95efb26a',
      alt: 'Priyanshu started working with CollegePass team in 2020',
    },
    {
      img: '/Verticle-success-stories/sheeja_cassius.jpg',
      m_img: '/testimonial/Sheeja_m.png',
      id: 'https://player.vimeo.com/video/507858570?autoplay=1',
      alt: 'Tulsi has been admitted to the University of Toronto, UBC, UC Berkeley, Kings College London and more.',
    },
    {
      img: '/testimonial/Raksha.png',
      m_img: '/Verticle-success-stories/raksha_mk.jpg',
      id: 'https://player.vimeo.com/video/534512207?autoplay=1',
      alt: 'Raksha has been admitted to Kelley School of Business, UMass Amherst, Indiana University, etc.',
    },
  ]

  return (
    <Fragment>
      <Container fluid className="pb-5">
        <Row>
          <Col className={styles.reviewBannerDetails}>
            <Row className={styles.reviewBannerText}>
              <Col>
                <Row className={styles.reviewBannerWidth}>
                  <Col>
                    <Row>
                      <Col>
                        <h1>
                          CollegePass Customer
                          <br /> Reviews
                        </h1>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Image src="/4.6-high-res.png" width="384" height="59" className={styles.reviewGoogleImg} />
                      </Col>
                    </Row>
                    {/* <Row>
                        <Col>
                            <button>Learn More</button>
                        </Col>
                    </Row> */}
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>

        <Container
          fluid
          style={{
            paddingLeft: '0px',
            paddingRight: '0px',
          }}
        >
          <Container
            style={{
              paddingLeft: '0px',
              paddingRight: '0px',
            }}
          >
            {/* <Row>
                <Col className='pt-5 mt-5'>
                    <Row className={styles.sliderSectionTop}>
                        <Col>
                            <Row>
                                <Col className={styles.SliderImgSection}>
                                    <Carousel>
                                        <Carousel.Item>
                                            <Image
                                                src="/georgia.jpg"
                                                width="990"
                                                height="600"
                                            />
                                        </Carousel.Item>
                                        <Carousel.Item>
                                            <Image
                                                src="/georgia.jpg"
                                                width="990"
                                                height="600"
                                            />
                                        </Carousel.Item>
                                        <Carousel.Item>
                                            <Image
                                                src="/georgia.jpg"
                                                width="990"
                                                height="600"
                                            />
                                        </Carousel.Item>
                                    </Carousel>
                                </Col>
                            </Row>
                        </Col>
                        <Col>
                            <Row>
                                <Col className={styles.SliderTextSection}>
                                    <h2>In-Depth Insights: Beyond the Numbers</h2>
                                    <p>Our journey with each student is unique and impactful, as evidenced by the 80% of students and families who awarded us a perfect 5-star rating. Moreover, 98.1% have rated us 4 or 5 stars, underscoring our consistent quality and effectiveness.</p>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Col>
            </Row> */}
            <Row>
              <Col
                className="pt-5"
                style={{
                  paddingLeft: '0px',
                  paddingRight: '0px',
                }}
              >
                <Row className={styles.reviewSectionHeading}>
                  <Col
                    style={{
                      paddingLeft: '0px',
                      paddingRight: '0px',
                    }}
                  >
                    <h2>WHAT STUDENTS & PARENTS ARE SAYING</h2>
                  </Col>
                </Row>

                <Row className={styles.mainBlockReview}>
                  <Col className={styles.reviewBlocks}>
                    <Row>
                      <Col className={styles.imgNameSection}>
                        <Row>
                          <Col className={styles.reviewIconBor}>
                            <Image
                              src="/review-icon.png"
                              width="50"
                              height="50"
                              style={{
                                marginTop: '-30px',
                              }}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <h5
                              style={{
                                color: '#ffffff',
                              }}
                            >
                              Nina Karra
                            </h5>
                            <h6>May 26, 2024</h6>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row>
                      <Col className={styles.ratingName}>
                        <Image src="/5-stars.svg" width="74" height="11" className={styles.reviewGoogleImg} />
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <p>College Pass - Tutoring</p>
                        <p>
                          I had a good experience with the tutoring program of College Pass. I found them responsive,
                          helpful and cooperative. They were prompt in their replies to my queries and monitored the
                          program closely as it was being taught. The tutor was experienced and took great care in
                          explaining concepts, giving practice papers and providing detailed feedback on mistakes so
                          that the necessary improvements could be made.
                        </p>
                      </Col>
                    </Row>
                  </Col>

                  <Col className={styles.reviewBlocks}>
                    <Row>
                      <Col className={styles.imgNameSection}>
                        <Row>
                          <Col className={styles.reviewIconBor}>
                            <Image
                              src="/review-icon.png"
                              width="50"
                              height="50"
                              style={{
                                marginTop: '-30px',
                              }}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <h5
                              style={{
                                color: '#ffffff',
                              }}
                            >
                              Ramesh Yendluri
                            </h5>
                            <h6>April 21, 2024</h6>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row>
                      <Col className={styles.ratingName}>
                        <Image src="/5-stars.svg" width="74" height="11" className={styles.reviewGoogleImg} />
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <p>
                          I wanted to take a moment to express my gratitude for the guidance and support college pass
                          team provided to my son throughout his college application process.
                        </p>
                        <p>
                          {' '}
                          I would like to thank Ms Bhushnin for her thorough understanding of the college admissions
                          landscape and insights into various universities, their programs, and their requirements were
                          invaluable in helping my son make informed decisions about where to apply. Your personalized
                          approach to understand my son's strengths, interests, and aspirations, you were able to offer
                          tailored advice that ultimately led to successful applications.
                        </p>
                        <p>
                          {' '}
                          I have no doubt that your guidance will continue to positively impact the lives of many
                          students in their pursuit of higher education.
                        </p>
                        <p> Thank you once again for all that you do.</p>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row className={styles.mainBlockReview}>
                  <Col className={styles.reviewBlocks}>
                    <Row>
                      <Col className={styles.imgNameSection}>
                        <Row>
                          <Col>
                            <Image
                              src="/testimonial-thumb/kushal_review.png"
                              width="50"
                              height="50"
                              style={{
                                marginTop: '-30px',
                              }}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <h5
                              style={{
                                color: '#ffffff',
                              }}
                            >
                              Kushal Jayakumar
                            </h5>
                            <h6>June 14, 2022</h6>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row>
                      <Col className={styles.ratingName}>
                        <Image src="/5-stars.svg" width="74" height="11" className={styles.reviewGoogleImg} />
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <p>
                          The process of applying to college was confusing to me. Sadly, my school counselors were of no
                          help to me, and my parents meant well but weren't experts. This left me feeling overwhelmed
                          and worried that I wouldn't stand out. The entire process of getting started was complicated
                          for me, but CollegePass guided me step by step. My counselors made the process so much easier
                          and helped me submit an application that I would not have been able to do on my own. They
                          assisted me in choosing schools that would maximize my chances of acceptance. My timelines
                          were also planned out by them and they stayed on top of me to get things done. We worked
                          through several drafts of my Common App personal statement until it felt like it represented
                          me. Each application I submitted presented me in the best possible light. CollegePass opened
                          the doors to so many opportunities for me. They are the most qualified tutors and mentors, and
                          CollegePass had the information I needed. It was amazing how they became so involved; they
                          give you such peace of mind.
                        </p>
                      </Col>
                    </Row>
                  </Col>
                  <Col className={styles.reviewBlocks}>
                    <Row>
                      <Col className={styles.imgNameSection}>
                        <Row>
                          <Col className={styles.reviewIconBor}>
                            <Image
                              src="/review-icon.png"
                              width="50"
                              height="50"
                              style={{
                                marginTop: '-30px',
                              }}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <h5
                              style={{
                                color: '#ffffff',
                              }}
                            >
                              James Crasto
                            </h5>
                            <h6>September 24, 2023</h6>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row>
                      <Col className={styles.ratingName}>
                        <Image src="/5-stars.svg" width="74" height="11" className={styles.reviewGoogleImg} />
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <p>
                          I’m delighted to write a few thankful words for CollegePass to help my son get admission into
                          the most preferred college of his liking. CollegePass is undoubtedly the best college
                          admission consultant in the business, with a team of experienced & professional counsellors
                          who guide candidates & parents through every step of the admission process. They helped a lot
                          to choose the right course, write a compelling personal statement, and apply to the best
                          colleges in the UK in the chosen field. My son getting offers from all the applied colleges in
                          UCAS itself speaks of their professionalism. And a big shout-out to Ms. Bushnin, who patiently
                          accommodated all the changes my teenage son subsequently requested midway. I had almost given
                          up, but she was pretty dedicated to make all necessary revisions and made the whole process
                          stress-free for us. I highly recommend CollegePass to anyone who wants to pursue higher
                          education in India or abroad – they ensure you get into your dream college!
                        </p>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row className={styles.mainBlockReview}>
                  <Col className={styles.reviewBlocks}>
                    <Row>
                      <Col className={styles.imgNameSection}>
                        <Row>
                          <Col>
                            <Image
                              src="/testimonial-thumb/Kabir_review.png"
                              width="50"
                              height="50"
                              style={{
                                marginTop: '-30px',
                              }}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <h5
                              style={{
                                color: '#ffffff',
                              }}
                            >
                              Kabir Hinduja
                            </h5>
                            <h6>June 4, 2022</h6>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row>
                      <Col className={styles.ratingName}>
                        <Image src="/5-stars.svg" width="74" height="11" className={styles.reviewGoogleImg} />
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <p>
                          CollegePass had a markable impact on every aspect of my application, from my SATs to my essays
                          and extra-curriculars. Above all what I loved most about my experience with CollegePass was
                          that instead of pressuring me into creating this Unrepresentative picture of myself on my
                          application (which I believe is a common fear) they helped me find ways to push myself in the
                          fields I was passionate about, and by the end of the process I was able to look at my
                          application and was able to proudly say it was the best representation of who I was, my
                          passions, achievements, character and ambitions.
                        </p>
                      </Col>
                    </Row>
                  </Col>
                  <Col className={styles.reviewBlocks}>
                    <Row>
                      <Col className={styles.imgNameSection}>
                        <Row>
                          <Col className={styles.reviewIconBor}>
                            <Image
                              src="/review-icon.png"
                              width="50"
                              height="50"
                              style={{
                                marginTop: '-30px',
                              }}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <h5
                              style={{
                                color: '#ffffff',
                              }}
                            >
                              Aryan Krishna Neeli
                            </h5>
                            <h6>January 31, 2023</h6>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row>
                      <Col className={styles.ratingName}>
                        <Image src="/5-stars.svg" width="74" height="11" className={styles.reviewGoogleImg} />
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <p>
                          Helped me through every step of the way and sought to solve all my questions and concerns. Got
                          into my Dream School thanks to them!
                          <br />
                          Special Thanks to Bushnin for all her guidance, support and quick responses!
                        </p>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row className={styles.mainBlockReview}>
                  <Col className={styles.reviewBlocks}>
                    <Row>
                      <Col className={styles.imgNameSection}>
                        <Row>
                          <Col>
                            <Image
                              src="/testimonial-thumb/Nivedha_review.png"
                              width="50"
                              height="50"
                              style={{
                                marginTop: '-30px',
                              }}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <h5
                              style={{
                                color: '#ffffff',
                              }}
                            >
                              Nivedha Chandramouli
                            </h5>
                            <h6>June 9, 2022</h6>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row>
                      <Col className={styles.ratingName}>
                        <Image src="/5-stars.svg" width="74" height="11" className={styles.reviewGoogleImg} />
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <p>
                          Choosing CollegePass as my counselor for getting me through the college application process
                          was one of the best decisions I’ve made. Balancing school work and going through the rigorous
                          application process, would’ve been extremely difficult without guidance. The weekly meetings
                          with Aakash And Jahnavi, where we were working on a schedule with timelines helped me stay
                          focused on smaller defined goals to be accomplished without getting overwhelmed with the whole
                          process. The tools that were provided to me to shortlist colleges and classify them as reach
                          and safety helped me to prioritize and narrow down a list of universities that would be the
                          best fit for me. I am so thankful to Aakash and Jahnavi for all their support in guiding me to
                          get admissions into my top choice of college, University Of Wisconsin, Madison as a direct
                          admit into the business school. It was very comforting to know that help was a phone call
                          away.
                        </p>
                      </Col>
                    </Row>
                  </Col>
                  <Col className={styles.reviewBlocks}>
                    <Row>
                      <Col className={styles.imgNameSection}>
                        <Row>
                          <Col>
                            <Image
                              src="/testimonial-thumb/Sheeja_review.png"
                              width="50"
                              height="50"
                              style={{
                                marginTop: '-30px',
                              }}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <h5
                              style={{
                                color: '#ffffff',
                              }}
                            >
                              Sheeja C
                            </h5>
                            <h6>June 4, 2022</h6>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row>
                      <Col className={styles.ratingName}>
                        <Image src="/5-stars.svg" width="74" height="11" className={styles.reviewGoogleImg} />
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <p>
                          It’s been a great journey with CollegePass for my older daughter who is now at UC Berkeley...
                          there were unknowns , so many unexpected(s) which we do /did not anticipate or do /did not
                          have the bandwidth or knowledge/experience to handle or work around... As much as the child
                          was doing and giving her best was on the top of things there is always some space that needs
                          support beyond school acads achievements and parenting... , CollegePass was a more than
                          personified entity that held hands and walked us through, with support in every possible way
                          for the child and parents.. CollegePass does more than guide, they also show students & make
                          them believe that they can do much more.It doesn't stop there,… they see the student through
                          and make it happen ! Thank you CollegePass... look forward to continuing this journey with my
                          younger one… thank you always..
                        </p>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row className={styles.mainBlockReview}>
                  <Col className={styles.reviewBlocks}>
                    <Row>
                      <Col className={styles.imgNameSection}>
                        <Row>
                          <Col>
                            <Image
                              src="/testimonial-thumb/dhruvan_shah_review.png"
                              width="50"
                              height="50"
                              style={{
                                marginTop: '-30px',
                              }}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <h5
                              style={{
                                color: '#ffffff',
                              }}
                            >
                              Dhruwan S Shah
                            </h5>
                            <h6>June 15, 2022</h6>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row>
                      <Col className={styles.ratingName}>
                        <Image src="/5-stars.svg" width="74" height="11" className={styles.reviewGoogleImg} />
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <p>
                          Collegepass efficaciously aids in a high-school student's admission experience by shedding a
                          ray of insight into university selection and offering unwavering support for all its academic
                          components.
                        </p>
                      </Col>
                    </Row>
                  </Col>
                  <Col className={styles.reviewBlocks}>
                    <Row>
                      <Col className={styles.imgNameSection}>
                        <Row>
                          <Col>
                            <Image
                              src="/testimonial-thumb/rutwik_nanal_review.png"
                              width="50"
                              height="50"
                              style={{
                                marginTop: '-30px',
                              }}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <h5
                              style={{
                                color: '#ffffff',
                              }}
                            >
                              Rutwik Nanal
                            </h5>
                            <h6>June 15, 2022</h6>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row>
                      <Col className={styles.ratingName}>
                        <Image src="/5-stars.svg" width="74" height="11" className={styles.reviewGoogleImg} />
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <p>
                          COLLEGEPASS turned out to be a major game changer in my US admissions process- it was
                          basically a huge help in covering everything right from my extracurriculars to my essay. I
                          started out as attending their SAT lectures, further attending their one-on-one lectures as to
                          improve the score. The staff were extremely helpful and provided necessary insights at every
                          milestone of the journey. CollegePass certainly helped me in everything, right from providing
                          me the mandatory essay reminders(which I used to procrastinate a lot) to deadlines and
                          important dates to remember. I was contacted a lot by various US admission counsellors, but
                          CollegePass, by instinct, was different. I had not expected high levels of reminders and
                          completions- along with a little bit of motivation to complete everything. Thus, this
                          institution really helped me overcome any hurdle presented in my way and score good colleges
                          with enough scholarships based on merit. Thank you.
                        </p>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row className={styles.mainBlockReview}>
                  <Col className={styles.reviewBlocks}>
                    <Row>
                      <Col className={styles.imgNameSection}>
                        <Row>
                          <Col>
                            <Image
                              src="/testimonial-thumb/ray_review.png"
                              width="50"
                              height="50"
                              style={{
                                marginTop: '-30px',
                              }}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <h5
                              style={{
                                color: '#ffffff',
                              }}
                            >
                              Ray Das
                            </h5>
                            <h6>June 22, 2022</h6>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row>
                      <Col className={styles.ratingName}>
                        <Image src="/5-stars.svg" width="74" height="11" className={styles.reviewGoogleImg} />
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <p>
                          CollegePass has helped me at every step of my application process. From suggesting in
                          expanding my extracurriculars to constructive advice on my personal statement, their support
                          has helped me in improving the quality of my application a lot. It was an amazing experience
                          working with them.
                        </p>
                      </Col>
                    </Row>
                  </Col>

                  <Col className={styles.reviewBlocks}>
                    <Row>
                      <Col className={styles.imgNameSection}>
                        <Row>
                          <Col className={styles.reviewIconBor}>
                            <Image
                              src="/review-icon.png"
                              width="50"
                              height="50"
                              style={{
                                marginTop: '-30px',
                              }}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <h5
                              style={{
                                color: '#ffffff',
                              }}
                            >
                              Loulit Legesse
                            </h5>
                            <h6>November 5, 2023</h6>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row>
                      <Col className={styles.ratingName}>
                        <Image src="/5-stars.svg" width="74" height="11" className={styles.reviewGoogleImg} />
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <p>
                          I am so lucky to have found CollegePass. I had many difficulties editing my graduate school
                          admission essays and needed much help. CollegePass has a ten essays package, but I only had
                          two papers to work on. I found that the ten essays package was too expensive for me.
                          CollegePass agreed to take on my two essays at a discounted price. When I sent them my papers,
                          I added notes on what I was most worried about in my writing, and they took that into account.
                          I need to submit my application very quickly, and they sent me both essays corrected within 6
                          hours (as I had asked for). I feel that I have gone through the most challenging parts of
                          editing my papers thanks to them, including shortening them significantly without losing any
                          meaning. I am incredibly grateful to CollegePass, Aakash, and his team for being very
                          responsive, taking on my essays, and doing an incredible job editing them.
                        </p>
                      </Col>
                    </Row>
                  </Col>
                </Row>

                <Row className={styles.mainBlockReview}>
                  <Col className={styles.reviewBlocks}>
                    <Row>
                      <Col className={styles.imgNameSection}>
                        <Row>
                          <Col>
                            <Image
                              src="/testimonial-thumb/Aparna_review.png"
                              width="50"
                              height="50"
                              style={{
                                marginTop: '-30px',
                              }}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <h5
                              style={{
                                color: '#ffffff',
                              }}
                            >
                              Aparna Jha
                            </h5>
                            <h6>May 28, 2022</h6>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row>
                      <Col className={styles.ratingName}>
                        <Image src="/5-stars.svg" width="74" height="11" className={styles.reviewGoogleImg} />
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <p>
                          I'd like to thank the CollegePass team, particularly Ms. Bushnin and Ms. Shaurya, for
                          assisting my son Arnav Jha in constructing his profile. Their advice and encouragement were
                          quite beneficial. My son will apply to many elite universities for the fall 2023 session.
                          Collegepass assists with the essay writing process and also gives thorough information on how
                          to prepare for internships, research, and international contests. Unless they recommend it,
                          these insights are not available to parents. Thank you once more for your prompt assistance
                          and direction. Regards, Aparna Jha
                        </p>
                      </Col>
                    </Row>
                  </Col>

                  <Col className={styles.reviewBlocks}>
                    <Row>
                      <Col className={styles.imgNameSection}>
                        <Row>
                          <Col className={styles.reviewIconBor}>
                            <Image
                              src="/review-icon.png"
                              width="50"
                              height="50"
                              style={{
                                marginTop: '-30px',
                              }}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <h5
                              style={{
                                color: '#ffffff',
                              }}
                            >
                              Megha Puskur
                            </h5>
                            <h6>August 16, 2022</h6>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row>
                      <Col className={styles.ratingName}>
                        <Image src="/5-stars.svg" width="74" height="11" className={styles.reviewGoogleImg} />
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <p>
                          The team was very helpful and always available to answer any questions or give advice. I was
                          very happy with the help I received with essay editing as well as planning extracurriculars,
                          college lists and applications.
                        </p>
                      </Col>
                    </Row>
                  </Col>
                </Row>

                <Row className={styles.mainBlockReview}>
                  <Col className={styles.reviewBlocks}>
                    <Row>
                      <Col className={styles.imgNameSection}>
                        <Row>
                          <Col>
                            <Image
                              src="/testimonial-thumb/ayan_review.png"
                              width="50"
                              height="50"
                              style={{
                                marginTop: '-30px',
                              }}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <h5
                              style={{
                                color: '#ffffff',
                              }}
                            >
                              Ayan
                            </h5>
                            <h6>June 9, 2022</h6>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row>
                      <Col className={styles.ratingName}>
                        <Image src="/5-stars.svg" width="74" height="11" className={styles.reviewGoogleImg} />
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <p>
                          My experience with the college pass team has been a very positive one as I felt their constant
                          support and guidance from day one and I believe this has helped me get into my dream college.
                        </p>
                      </Col>
                    </Row>
                  </Col>

                  <Col className={styles.reviewBlocks}>
                    <Row>
                      <Col className={styles.imgNameSection}>
                        <Row>
                          <Col className={styles.reviewIconBor}>
                            <Image
                              src="/review-icon.png"
                              width="50"
                              height="50"
                              style={{
                                marginTop: '-30px',
                              }}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <h5
                              style={{
                                color: '#ffffff',
                              }}
                            >
                              Hima Bollineni
                            </h5>
                            <h6>November 18, 2022</h6>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row>
                      <Col className={styles.ratingName}>
                        <Image src="/5-stars.svg" width="74" height="11" className={styles.reviewGoogleImg} />
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <p>
                          Bushnin was very helpful and courteous with the college SOP, essays and application process.
                          She was very prompt with her responses and helping my son with end to end in his US college
                          applications. Thanks you, Bushnin for the help and support given to us during this engagement.
                        </p>
                      </Col>
                    </Row>
                  </Col>
                </Row>

                <Row className={styles.mainBlockReview}>
                  <Col className={styles.reviewBlocks}>
                    <Row>
                      <Col className={styles.imgNameSection}>
                        <Row>
                          <Col className={styles.reviewIconBor}>
                            <Image
                              src="/review-icon.png"
                              width="50"
                              height="50"
                              style={{
                                marginTop: '-30px',
                              }}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <h5
                              style={{
                                color: '#ffffff',
                              }}
                            >
                              Rinka Banerjee
                            </h5>
                            <h6>June 10, 2022</h6>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row>
                      <Col className={styles.ratingName}>
                        <Image src="/5-stars.svg" width="74" height="11" className={styles.reviewGoogleImg} />
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <p>
                          As a parent it was very comforting to work with a counselor and the team who were very
                          accessible, and made a plan that kept the child's goals in their mind. The approach was
                          holistic and personalised and not just advising on which colleges. A special thanks to his
                          counselor who was reachable at all times, mentored our son and motivated him at down times and
                          to the team for the support he recieved during his essay writing and sat prep. Highly
                          recommend them to parents and children who are looking for a personalised approach in this
                          journey.
                        </p>
                      </Col>
                    </Row>
                  </Col>

                  <Col className={styles.reviewBlocks}>
                    <Row>
                      <Col className={styles.imgNameSection}>
                        <Row>
                          <Col className={styles.reviewIconBor}>
                            <Image
                              src="/review-icon.png"
                              width="50"
                              height="50"
                              style={{
                                marginTop: '-30px',
                              }}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <h5
                              style={{
                                color: '#ffffff',
                              }}
                            >
                              Sreekruthi Sallaram
                            </h5>
                            <h6>November 10, 2022</h6>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row>
                      <Col className={styles.ratingName}>
                        <Image src="/5-stars.svg" width="74" height="11" className={styles.reviewGoogleImg} />
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <p>
                          Wonderful service provided, the advisors were with me throughout the process, from providing
                          the information on countries, colleges and even down to the program, even the editor who
                          helped with the SOP gave her insights and helped give the amazing output i got. Overall the
                          advisors and editors are extremely knowledgeable and professional and understand the time
                          sensitivity factor, would recommend to anyone who requires assistance from scratch.
                        </p>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </Container>
      </Container>
    </Fragment>
  )
}

export default index
